export default "__VITE_ASSET__DJJqTPDV__"